import React, {StrictMode} from "react";

import "./index.shared";
import {Nav, ProductLayout} from "./twtheme";
import {createRoot} from "react-dom/client";
import {QueryClient, QueryClientProvider} from "react-query";
import {LocaleProvider} from "./localization/LocaleProvider";
import LocalizedShopifyProvider from "./LocalizedShopifyProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const rootContainer = document.getElementById("react-recipe");

if (rootContainer) {
  const root = createRoot(rootContainer);
  root.render(
    <QueryClientProvider client={queryClient}>
      <StrictMode>
        <LocaleProvider>
          <LocalizedShopifyProvider>
            <Nav logoUrl={window.logoUrl} customerName={window.customerName} />
            <ProductLayout
              productJson={window.productJson}
              demovideoUrl={window.demovideoUrl}
              testimonialPortraitUrl={window.testimonialPortraitUrl}
            />
          </LocalizedShopifyProvider>
        </LocaleProvider>
      </StrictMode>
    </QueryClientProvider>,
  );
}
